import { render, staticRenderFns } from "./AppsCreatePage.vue?vue&type=template&id=72ce5e51&"
import script from "./AppsCreatePage.vue?vue&type=script&lang=js&"
export * from "./AppsCreatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports